import { Dropdown, DropdownProps } from 'antd'

export interface KBDropdownProps extends DropdownProps {}

export function KBDropdown(props: KBDropdownProps) {
  return <Dropdown {...props}></Dropdown>
}

KBDropdown.Button = Dropdown.Button
